import { Admin } from 'types';

export const getAdminFullName = (admin: Admin) => `${admin.first_name} ${admin.last_name}`;
